import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputBS } from './inputbs.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { AutocompleteModule } from '../autocomplete';
import { FechaModule } from '../fecha';
import { ComponentesService } from '../componentes.service';

@NgModule({
	declarations: [
		InputBS
	],
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		MatBottomSheetModule,
		MatFormFieldModule,
		MatInputModule,
		MatIconModule,
		MatButtonModule,
		AutocompleteModule,
		FechaModule,
		MatIconModule
	],
	exports: [
		InputBS
	],
	entryComponents: [
		InputBS
	],
	providers: [
		ComponentesService
	]
})
export class InputBSModule { }
